import BaseService from "./base.service";
import { Singleton } from "util";
import { ApiResourceBuilder } from "core/builder";

@Singleton
class SefazAcronymsService extends BaseService {
  async getSefazNcm() {
    return await this.get(`/v1/sefaz_acronyms/ncms.json`);
  }

  async getSefazCfop() {
    return await this.get(`/v1/sefaz_acronyms/cfops.json`);
  }

  async getSefazCest() {
    return await this.get(`/v1/sefaz_acronyms/cests.json`);
  }

  async getSefazCsosn() {
    return await this.get(`/v1/sefaz_acronyms/cst_csosns.json`);
  }

  async filterSefazNcm(filters = []) {
    const resourceRoute = ApiResourceBuilder.buildFromParams(
      "/v1/sefaz_acronyms/ncms.json",
      { filters }
    );
    return await this.get(resourceRoute);
  }

  async filterSefazCfop(filters = []) {
    const resourceRoute = ApiResourceBuilder.buildFromParams(
      "/v1/sefaz_acronyms/cfops.json",
      { filters }
    );
    return await this.get(resourceRoute);
  }

  async filterSefazCest(filters = []) {
    const resourceRoute = ApiResourceBuilder.buildFromParams(
      "/v1/sefaz_acronyms/cests.json",
      { filters }
    );
    return await this.get(resourceRoute);
  }

  async filterSefazCsosn(filters = []) {
    const resourceRoute = ApiResourceBuilder.buildFromParams(
      "/v1/sefaz_acronyms/cst_csosns.json",
      { filters }
    );
    return await this.get(resourceRoute);
  }
}

export default SefazAcronymsService;



// WEBPACK FOOTER //
// ./src/core/service/sefaz-acronyms.service.js